import {emailValidator} from '../../../utils/Validate';

export const validate = (values: any): any => {
  const errors: any = {};
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.email = 'Please enter username!';
  } else if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.password = 'Please enter password';
  }
  return errors;
};
// Takes date object
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getDiffInSeconds = (timeObj1: any, timeObj2: any) => {
  const diff = (timeObj1.getTime() - timeObj2.getTime()) / 1000;
  return Math.abs(Math.round(diff));
};

export const validateHookForm = (values: any): any => {
  const errors = [];
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.push({name: 'email', type: '', message: 'Please enter username!'});
  } else if (emailValidator(values.email) === false) {
    errors.push({
      name: 'email',
      type: '',
      message: 'Please enter valid email!'
    });
  } else if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.push({
      name: 'password',
      type: '',
      message: 'Please enter password!'
    });
  }
  return errors;
};
